import React from 'react';
import { Switch } from 'react-router-dom';

import AuthRoute from '../AuthRoute';

import LandlordType from '../components/pmcClientReg/LandlordType';
import PmcLinkedEnterprise from '../components/pmcClientReg/PmcLinkedEnterprise';
import PmcLinkedEnterpriseNumber from '../components/pmcClientReg/PmcLinkedEnterpriseNumber';
import CompanyRegistrationNumber from '../components/pmcClientReg/CompanyRegistrationNumber';
import PmcClientConfirmBusinessDetails from '../components/pmcClientReg/PmcClientConfirmBusinessDetails';
import PmcClientVATNumber from '../components/pmcClientReg/PmcClientVATNumber';
import PmcConfirmVAT from '../components/pmcClientReg/pmcConfirmVAT';
import CheckAnswers from '../components/pmcClientReg/CheckAnswers';
import Declaration from '../components/pmcClientReg/Declaration';
import CannotProceed from '../components/pmcClientReg/CannotProceed';
import AccountCreated from '../components/pmcClientReg/AccountCreated';
import PmcClientRegistered from '../components/pmcClientReg/PmcClientRegistered';

export default function RoutesTreePmcClientReg() {
  return (
    <Switch>
      {/* *************************** */}
      {/* PMC Client Registration routes */}
      {/* *************************** */}
      <AuthRoute exact path="/pmcClientReg/type-of-landlord">
        <LandlordType />
      </AuthRoute>
      <AuthRoute exact path="/pmcClientReg/linked-enterprise">
        <PmcLinkedEnterprise />
      </AuthRoute>
      <AuthRoute
        exact
        path="/pmcClientReg/linked-enterprise-number"
        isAnonymous
      >
        <PmcLinkedEnterpriseNumber />
      </AuthRoute>
      <AuthRoute
        exact
        path="/pmcClientReg/company-registration-number"
        isAnonymous
      >
        <CompanyRegistrationNumber />
      </AuthRoute>
      <AuthRoute exact path="/pmcClientReg/confirm-business-details">
        <PmcClientConfirmBusinessDetails />
      </AuthRoute>
      <AuthRoute exact path="/pmcClientReg/company-VAT-number">
        <PmcClientVATNumber />
      </AuthRoute>
      <AuthRoute exact path="/pmcClientReg/confirm-business-VAT">
        <PmcConfirmVAT />
      </AuthRoute>
      <AuthRoute exact path="/pmcClientReg/check-your-answers">
        <CheckAnswers />
      </AuthRoute>
      <AuthRoute exact path="/pmcClientReg/declaration">
        <Declaration />
      </AuthRoute>
      <AuthRoute exact path="/pmcClientReg/cannot-proceed">
        <CannotProceed />
      </AuthRoute>
      <AuthRoute exact path="/pmcClientReg/account-created">
        <AccountCreated />
      </AuthRoute>
      <AuthRoute exact path="/pmcClientReg/linked-enterprise">
        <PmcLinkedEnterprise />
      </AuthRoute>
      <AuthRoute exact path="/pmcClientReg/linked-enterprise-number">
        <PmcLinkedEnterpriseNumber />
      </AuthRoute>
      <AuthRoute exact path="/pmcClientReg/company-registration-number">
        <CompanyRegistrationNumber />
      </AuthRoute>
      <AuthRoute exact path="/pmcClientReg/client-registered">
        <PmcClientRegistered />
      </AuthRoute>
    </Switch>
  );
}
